import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import {
    deleteLandingPage,
    getCloneLandingPage,
    getLandingPages,
} from "../../../redux/slices/landingPages/landingPages.asyncActions";
import {
    clearState,
    setLandingPageDetails,
} from "../../../redux/slices/landingPages/landingPages.slice";
import LandingPages from "./LandingPages.layout";

const mapStateToProps = (state: any) => ({
    langugage: state.languagesState.languages,
    landingPages: state.landingPages.landingPages,
    isCloneLandingPageLoading: state.landingPages.isCloneLandingPageLoading,
    deletingLandingPageId: state.landingPages.deletingLandingPageId,
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchGetLandingPages: (params: any) => dispatch(getLandingPages(params)),
    dispatchDeleteLandingPage: (id: number) => dispatch(deleteLandingPage(id)),
    dispatchSetLandingPageDetails: (landingPage: any) =>
        dispatch(setLandingPageDetails(landingPage)),
    dispatchCloneLandingPage: (id: number) => dispatch(getCloneLandingPage(id)),
    dispatchClearState: (payload: any) => dispatch(clearState(payload)),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(LandingPages);
